export const getPathNameLocale = ({ slash }: { slash: boolean }): string => {
  const firstPathName = window.location.pathname.split('/')[1];
  const prefix = slash ? '/' : '';
  const isValidLanguage =
    firstPathName === Language.TH || firstPathName === Language.ID; // Might need to add ZH when Zh is added

  return isValidLanguage ? `${prefix}${String(firstPathName)}` : '';
};

export enum Language {
  ZH = 'zh',
  TH = 'th',
  ID = 'id',
}
